import React from 'react';
import KycGenericVerification from './KycGenericVerification';

export default function KycMobileToBankAccount() {
  return (
    <KycGenericVerification
      title="Mobile To Bank Account"
      description="Obtain the bank account holder name, un-masked account number, IFSC and UPI ID linked to a mobile number."
      kycType="mobile-to-bank-account"
      costField="mobileToBankAccountCost"
      submitLabel="Submit Mobile To Bank Account"
      inputs={[
        {
          name: 'mobileNumber',
          label: 'Mobile Number',
          placeholder: '9876543210',
          maxLength: 10,
          formatter: (value) => String(value || '').replace(/\D/g, '').slice(0, 10),
          validator: (value) => /^\d{10}$/.test(String(value || '')),
          errorMessage: 'Enter a valid 10 digit mobile number'
        }
      ]}
      referenceFormatter={(item) => item.mobileNumber || 'N/A'}
    />
  );
}
